import React from 'react';
import {
  calculateSumOfEachRow,
  deleteRowHandler,
  myCustomCelEditFunction,
  updateTableCellHandler
} from "../SellFactor/SellFactorFunctions";
import tableCalc from "../../utils/tableCalc";
import {ReactTabulator} from "react-tabulator";
import tabulatorTableOptions from "../../utils/TabulatorTableOptions";
import NewTabulator from "../NewTabulator/NewTabulator";
import numeric from "../../utils/NumericFunction";
import {parseToEnRemoveComma} from "../../utils/CommaSeparator";
import utilsFunction from "../../utils/utilsFunction";
import {updateTableCellHandlerSadan} from "../SellFactorSdanaShop/SellFactorFunctionsSadan";

const TransferBetweenStoresTable = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {

  const tableColumns = [{
    title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
    maxWidth: 100, headerHozAlign: "center",
    style: {width: '300px', overflow: 'hidden'},
    cellClick: function (e, cell) {
      const productId = cell.getData().productId;
      const storeId = cell.getData().storeId;
      const tableData = deleteRowHandler(sendData.tableData, productId, storeId);
      setSendData({tableData})

    }
  },

    {title: "گروه کالا", field: 'productGroup',visible: false},
    {title: "کد گروه کالا", field: 'productGroupId',visible: false},
    {field: "seriesId", visible: false,},
    {title: "کد کالا", field: 'productId', visible: false,},
    {title: "نام کالا", field: 'productName',},

    {field: "recordId", visible: true,},

    {title: "کد انبار", field: "storeId", visible: false,},
    {title: "مبدا", field: "storeName", visible: false,},
    {title: "کد انبار مقصد", field: "destinationStoreId", visible: false,},
    {title: "مقصد", field: "destinationStoreName", visible: false,},



    {title: "packId", field: 'packId',visible: false},
    {title: "نوع کالا", field: 'type',visible: false},
    {title: "نوع کالا", field: 'typeShow',visible: true},
    {title: "وزن", field: 'weight',visible: true,editor:"number",
      formatter: tableCalc.persianDigits,
      bottomCalc:"sum",
      style: {textAlign:'center'},
      cellEdited: function (e, cell) {
        // const value = parseToEnRemoveComma(e.target.value);

        let value = (e.target.value);
        console.log(value)
        console.log(value.length)
        if (value === "") {
          value = "0"
        }

        value = numeric.p2e(value)

        value = utilsFunction.LimitDotAndThreeCharsAfterDot(value)
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;

        if(type==='bulk'){
          const tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "weight", value,type);
          setSendData({tableData})
        }

       }

    },

  ];

  // const celEditHandler = cell => {
  //
  //   console.log(sendData.tableData)
  //   // calculateSumOfEachRow(sendData.tableData)
  //   setSendData({tableData: calculateSumOfEachRow(sendData.tableData)})
  // }

  console.log("Render Transfer")

  return (
    <div className="separate-factor__newSellComponent"
      // ref={seperateFac}
    >
      <NewTabulator
        columns={tableColumns}
        data={[...sendData.tableData]}
        style={{height: "70vh", overflow: 'scroll'}}
        className={"header__color__F1F1F1"}

      />

      {/*<ReactTabulator*/}
      {/*  columns={tableColumns}*/}
      {/*  data={sendData.tableData}*/}
      {/*  options={tabulatorTableOptions.tableOptions}*/}
      {/*  style={{height: "70vh"}}*/}
      {/*/>*/}

    </div>
  );
};

export default TransferBetweenStoresTable;
